import React, { useEffect, useState, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { MarketCalculusCard } from '../../../components/preview/Preview'
import { RSelect } from '../../../components/Component'
import { useGlobalStoreData } from '../../../store/globalStore'
import { RegistryFirmsServices } from '../../../services/McDataServices'
import { useSDSsearchParams } from '../../../store/searchDataStore'
import FirmListServerSide from '../../../mailTemplate/src/components/atomic/organisms/FirmListServerSide'
import '../../../assets/scss/apps/_serverside-table.scss'

const TradeRegistryTabs = ({ id, dropdownData, tableData, setTableData, selectedOptions, setSelectedOptions }) => {
  const { t } = useTranslation()
  const searchParams = useSDSsearchParams()
  const languageGSD = useGlobalStoreData.language()
  const [rawData, setRawData] = useState({})
  const [loading, setLoading] = useState(false)
  const [serverSidePagination, setServerSidePagination] = useState({ pageSize: 10 })
  const requestRef = useRef(null)

  useEffect(() => {
    if (!selectedOptions.length) {
      setTableData(id, [])
      return
    }

    const controller = new AbortController()
    requestRef.current = controller

    const fetchData = async () => {
      try {
        setLoading(true)
        const payload = {
          importerCountryCode: searchParams.countryToExport,
          currentCountryCode: searchParams.yourCountry,
          hsCodes: searchParams.hsCode,
          sectorCodes: selectedOptions.map(opt => opt.code).join(';'),
          page: serverSidePagination.pageIndex ?? 0,
          ...serverSidePagination
        }
        const response = await RegistryFirmsServices.getFirms(payload, { signal: controller.signal })
        if (!controller.signal.aborted) {
          setRawData(response || [])
          setTableData(id, response?.registryFirms || [])
        }
      } catch (error) {
        if (error.name !== 'AbortError') {
          console.error('Data fetch error:', error)
          setTableData(id, [])
        }
      } finally {
        if (!controller.signal.aborted) setLoading(false)
      }
    }

    fetchData()
    return () => controller.abort()
  }, [selectedOptions, serverSidePagination])

  const handleChange = selected => setSelectedOptions(id, selected || [])

  return (
    <MarketCalculusCard>
      <div className="flex align-items-center">
        <h5 className="mb-0">{t('mailTemplate.wizard.firmList.sector')}</h5>
        <div style={{ minWidth: 250, paddingInlineStart: 10 }}>
          <RSelect
            id="firmOptions"
            options={dropdownData}
            isMulti
            value={selectedOptions}
            hideSelectedOptions={false}
            closeMenuOnSelect={false}
            onChange={handleChange}
            getOptionValue={opt => opt.code}
            getOptionLabel={opt => `${opt.code}${opt?.name?.[languageGSD] ? `-${opt.name[languageGSD]}` : ''}`}
            formatOptionLabel={(opt, { context }) => (
              context === 'menu'
                ? (
                <div className="format-option-label" style={selectedOptions.some(s => s.code === opt.code) ? { color: 'red' } : {}}>
                  <span>{`${opt.code}${opt?.name?.[languageGSD] ? `-${opt.name[languageGSD]}` : ''}`}</span>
                </div>
                  )
                : opt.code
            )}
          />
        </div>
      </div>
      <div className="my-3">
        <FirmListServerSide
          setServerSidePaginationByKey={setServerSidePagination}
          serverSidePagination={serverSidePagination}
          data={tableData || []}
          rowCount={rawData?.totalRecordCount || 0}
          fetching={loading}
          languageGSD={languageGSD}
          className="serverside-table"
        />
      </div>
    </MarketCalculusCard>
  )
}

export default TradeRegistryTabs
